module.exports = __webpack_public_path__ + "tenant-tag-sets.9d0c36838b894a69ca051229b5fdd530.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/intro/tenant-tag-sets.png
// module id = 3096203308683825
// module chunks = 1